var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 22.5 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#9e4db6;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M684.19,381.38a.94.94,0,1,0-1.87,0v7.11l-2.15-2.15a.94.94,0,0,0-1.33,1.33l3.75,3.75a.93.93,0,0,0,1.32,0h0l3.75-3.75a1,1,0,0,0,0-1.33.94.94,0,0,0-1.33,0l-2.15,2.15Z",
    transform: "translate(-672 -369.19)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M694.5,395.44V377.63l-8.43-8.44H675.75a3.75,3.75,0,0,0-3.75,3.75v22.5a3.75,3.75,0,0,0,3.75,3.75h15A3.75,3.75,0,0,0,694.5,395.44Zm-8.43-20.62a2.81,2.81,0,0,0,2.81,2.81h3.75v17.81a1.88,1.88,0,0,1-1.88,1.88h-15a1.88,1.88,0,0,1-1.87-1.88v-22.5a1.87,1.87,0,0,1,1.87-1.87h10.32Z",
    transform: "translate(-672 -369.19)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadIcon);
export default __webpack_public_path__ + "static/media/download-icon.0d21cbf93a63e0e01fd341e79507a30f.svg";
export { ForwardRef as ReactComponent };